import {putAll, showBeError, showSuccess, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {opt} from 'ts-opt';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';

import {DeleteMilkabilityReportAction, milkabilityAction} from '../action';

const te = t('milkability');

function* execute(action: DeleteMilkabilityReportAction): SagaIterator {
    const {id, refreshMilkabilityTable} = action.payload;

    yield* put(milkabilityAction.setLoading('deleteCreatedMilkabilityReport', true));

    const response = yield* call(Api.deleteMilkabilityReport, {id});

    if (response.isSuccess) {
        yield* put(showSuccess(te('deleteMilkabilityReport'), te('reportDeletedSuccessfully')));
        if (refreshMilkabilityTable) yield* put(milkabilityAction.getMilkabilityReports(opt({action: 'refresh'})));
        yield* put(milkabilityAction.deleteMilkabilityReportSuccess(id));
        yield* put(milkabilityAction.setEditingMilkabilityReportId(undefined));
    } else {
        yield putAll(showBeError(response, te('deleteMilkabilityReport')));
    }

    yield* put(milkabilityAction.setLoading('deleteCreatedMilkabilityReport', false));
}

/** Watches milkability delete requests and removes reports from the active workflow. */
export function* deleteMilkabilityReportSaga(): SagaIterator {
    yield takeLatestF('milkability/DELETE_MILKABILITY_REPORT', execute);
}
